import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { STATS } from "@/data/site";
import { toFa } from "@/lib/fa";
import { Stagger, StaggerItem, Reveal } from "@/components/Reveal";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const dur = 1700;
    const t0 = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min((t - t0) / dur, 1);
      setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);
  return (
    <span ref={ref} className="font-display text-3xl font-black text-gold sm:text-4xl">
      {toFa(n)}{suffix}
    </span>
  );
};

export default function StatsBand() {
  return (
    <div className="relative border-y border-gold/10 bg-navy-900/50" data-testid="stats-band">
      <Stagger className="mx-auto grid max-w-7xl grid-cols-2 gap-y-10 px-5 py-14 md:grid-cols-4 lg:px-8">
        {STATS.map((s) => (
          <StaggerItem key={s.label} className="flex flex-col items-center gap-2 text-center">
            <Counter value={s.value} suffix={s.suffix} />
            <span className="text-sm text-slate-400">{s.label}</span>
          </StaggerItem>
        ))}
      </Stagger>
      <Reveal className="pointer-events-none absolute inset-0" y={0}>
        <div className="mx-auto h-px max-w-3xl bg-gradient-to-l from-transparent via-gold/40 to-transparent" />
      </Reveal>
    </div>
  );
}
